import type { FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import type { ProjectFile, User } from "@/graphql.ts";
import { FileTile } from "@/modules/files/components/FileTile.js";

export interface ISampleReportsCardProps extends GridCard {
  reports: ProjectFile[];
  currUser: User;
}

const SampleReportsCard: FC<ISampleReportsCardProps> = (props) => {
  if (props.reports.length === 0) {
    return null;
  }

  return (
    <Card
      shrinkable={props.reports.length > 7}
      key="sample-info-card"
      title={"Reports"}
      tag={{ label: String(props.reports.length) }}
    >
      <CardRowSimple>
        {props.reports.map((rep) => (
          <FileTile file={rep} key={"ref-card-elem-" + rep.id} />
        ))}
      </CardRowSimple>
    </Card>
  );
};

export default SampleReportsCard;
export { SampleReportsCard };
